module.exports = __webpack_public_path__ + "c0b2b49a63ededb5d6fb589b39950c9c.svg";